import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserCompetency } from 'app/_models/competency.model';
import { CompetencyService } from 'app/_services/competency.service';
import { NotificationService } from 'app/_services/notification.service';
import DateTimeUtils from 'app/_utils/datetime.utils';

@Component({
  selector: 'upload-evidence-modal',
  templateUrl: './upload-evidence-modal.component.html',
})
export class UploadEvidenceModalComponent {
  @Input() competency: UserCompetency;
  @Input() siteOwnerId: number;

  public selectedDocument: File = null;
  public expiryDate: Date = null;
  public saveInProgress = false;
  public today: Date = new Date();
  private currentYear = new Date().getFullYear();
  public datepickerYearRange = this.currentYear + ':' + (this.currentYear + 10);

  constructor(
    private activeModal: NgbActiveModal,
    private competencyService: CompetencyService,
    private notificationService: NotificationService,
  ) {}

  public closeModal(): void {
    this.activeModal.dismiss();
  }

  public onFileSelected(event: any): void {
    this.selectedDocument = event.target.files[0] || null;
  }

  public upload(): void {
    if (this.saveInProgress || !this.selectedDocument || !this.competency || !this.competency.id || !this.siteOwnerId) {
      return;
    }

    if (!this.expiryDate || this.isExpiryDateInPast) {
      return;
    }

    const expiryDateStr = DateTimeUtils.localDateToTimelessString(this.expiryDate);

    this.saveInProgress = true;
    this.competencyService.uploadCompetencyEvidence(this.competency.id, this.siteOwnerId, this.selectedDocument, expiryDateStr).subscribe(
      () => {
        this.notificationService.notify('success', 'Evidence uploaded');
        this.activeModal.close('refresh');
      },
      (error) => {
        if (error && error.message === 'Infected') {
          this.notificationService.notify('danger', 'File is infected with malware!');
        } else if (error && error.message === 'EmbeddedScript') {
          this.notificationService.notify('danger', 'File has an embedded script');
        } else {
          this.notificationService.notify('danger', 'Error uploading evidence');
        }
        this.saveInProgress = false;
      }
    );
  }

  public get isExpiryDateInPast(): boolean {
    if (!this.expiryDate) {
      return false;
    }

    return DateTimeUtils.isDateExpired(this.expiryDate);
  }
}
